import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const overview = createAsyncThunk(
  'Saada/saadaUnionDeleteAnchor/get_deleted_anchor_overview',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_deleted_anchor_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home?: {
    total_times: number // 总退出次数（本周期间）
    today_times: number // 今天退出次数
  }
}

const initialState: InitialStateType = {}

export const SaadaUnionDeleteAnchorSlice = createSlice({
  name: 'SaadaUnionDeleteAnchor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(overview.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
  },
})
export default SaadaUnionDeleteAnchorSlice.reducer
export const SaadaUnionDeleteAnchorActions = SaadaUnionDeleteAnchorSlice.actions

export const useSaadaUnionDeleteAnchorState = () => {
  const data = useSelector((state) => {
    return state.SaadaUnionDeleteAnchor
  })
  return data
}
